module.exports = __webpack_public_path__ + "img/sa.f252768e.png";